<script>

  import BaseButton from "@/public/components/common/uiKit/button/base/index.vue";

  export default{
    name: "integrationsSettings",
    components: {BaseButton}
  }
</script>

<template>
<div class="docs">
  <div>
    <div class="header">
      <div class="docs__title">
        {{ $t('testnet.settings-title') }}
      </div>
      <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_22718_31495)">
          <circle cx="27" cy="27" r="27" fill="var(--bg-background-table)"/>
          <path d="M25.2533 13.3634C25.7083 11.5455 28.2917 11.5455 28.7467 13.3634L28.8808 13.8992C29.2238 15.2696 30.9393 15.7293 31.9216 14.7139L32.3056 14.317C33.6086 12.9702 35.8459 14.2619 35.331 16.0637L35.1792 16.5947C34.7911 17.9531 36.0469 19.2089 37.4053 18.8208L37.9363 18.669C39.7381 18.1541 41.0298 20.3914 39.683 21.6944L39.2861 22.0784C38.2707 23.0607 38.7304 24.7762 40.1009 25.1192L40.6366 25.2533C42.4545 25.7083 42.4545 28.2917 40.6366 28.7467L40.1008 28.8808C38.7304 29.2238 38.2707 30.9393 39.2861 31.9216L39.683 32.3056C41.0298 33.6086 39.7381 35.8459 37.9363 35.331L37.4053 35.1792C36.0469 34.7911 34.7911 36.0469 35.1792 37.4053L35.331 37.9363C35.8459 39.7381 33.6086 41.0298 32.3056 39.683L31.9216 39.2861C30.9393 38.2707 29.2238 38.7304 28.8808 40.1009L28.7467 40.6366C28.2917 42.4545 25.7083 42.4545 25.2533 40.6366L25.1192 40.1008C24.7762 38.7304 23.0607 38.2707 22.0784 39.2861L21.6944 39.683C20.3914 41.0298 18.1541 39.7381 18.669 37.9363L18.8208 37.4053C19.2089 36.0469 17.9531 34.7911 16.5947 35.1792L16.0637 35.331C14.2619 35.8459 12.9702 33.6086 14.317 32.3056L14.7139 31.9216C15.7293 30.9393 15.2696 29.2238 13.8991 28.8808L13.3634 28.7467C11.5455 28.2917 11.5455 25.7083 13.3634 25.2533L13.8992 25.1192C15.2696 24.7762 15.7293 23.0607 14.7139 22.0784L14.317 21.6944C12.9702 20.3914 14.2619 18.1541 16.0637 18.669L16.5947 18.8208C17.9531 19.2089 19.2089 17.9531 18.8208 16.5947L18.669 16.0637C18.1541 14.2619 20.3914 12.9702 21.6944 14.317L22.0784 14.7139C23.0607 15.7293 24.7762 15.2696 25.1192 13.8991L25.2533 13.3634ZM36.3243 27.9371H27.4685L22.1546 35.0223C23.5685 35.8781 25.2267 36.3706 27 36.3706C31.859 36.3706 35.8542 32.6724 36.3243 27.9371ZM36.3243 26.063C35.8542 21.3277 31.859 17.6294 27 17.6294C25.2267 17.6294 23.5685 18.122 22.1546 18.9778L27.4685 26.063H36.3243ZM21.4649 19.4381C21.4101 19.4783 21.3558 19.519 21.3019 19.5604L21.4649 19.4381ZM20.6561 20.1033C18.7953 21.8159 17.6294 24.2718 17.6294 27C17.6294 29.7283 18.7953 32.1842 20.6561 33.8967L25.8287 27L20.6561 20.1033ZM21.3019 34.4397C21.3558 34.481 21.4101 34.5218 21.4649 34.562L21.3019 34.4397Z" fill="var(--bg-background-primary-purple)"/>
        </g>
        <defs>
          <clipPath id="clip0_22718_31495">
            <rect width="54" height="54" rx="27" fill="white"/>
          </clipPath>
        </defs>
      </svg>

    </div>
    <div class="docs__desc">
      {{ $t('testnet.settings-desc') }}
    </div>
  </div>

  <div class="docs__links">
    <router-link to="/integration-settings">
      <base-button type="primary">
        <template #label>
          <span class="label">{{ $t('testnet.redirect') }}</span>
        </template>
      </base-button>
    </router-link>
  </div>
</div>
</template>

<style scoped lang="scss">
.docs {
  height: 100%;
  width: 100%;
  padding: 30px;
  border-radius: 30px;
  background: var(--bg-background-secondary);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  &__desc {
    color: var(--text-color-text-secondary);
    font-size: 16px;
    font-weight: 500;
    line-height: 130%;
    margin-top: 11px;
  }
  &__links {
    display: flex;
    flex-direction: column;
    gap:  10px;
  }
  &__title {
    color: var(--text-text-primary);
    font-size: 32px;
    font-style: normal;
    font-weight: 500;
    line-height: 100%;
  }
}
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
